<template>
  <v-container>
      hola mundo!
  </v-container>
</template>

<script>

  export default {
    name: 'Home2'
  }
</script>
